import { Route, RouteObject } from 'react-router-dom';
import { Meters } from './components';
import MeterDetails from './components/Meters/components/MeterDetails/MeterDetails';
import AddEditMeter from './components/Meters/components/AddEditMeter';
import MeterInventoryManager from './components/Inventory/MeterInventoryManager';
import { WorkOrders } from './components/ServiceOrder/WorkOrders';
import CreateServiceOrder from './components/ServiceOrder/create/create';

export interface mxDeviceManagementRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxDeviceManagementRoute[];
}

export const mxDeviceManagementRoutes: mxDeviceManagementRoute[] = [
  {
      path: 'mx/device-management/meter',
      element: <Meters />,
  },
  {
      path: 'mx/device-management/meter/view/:id',
      element: <MeterDetails />,
  },
  {
    path: 'mx/device-management/meter/create',
    element: <AddEditMeter />
  },
  {
    path: 'mx/device-management/meter/edit/:id',
    element: <AddEditMeter />
  },
  {
    path: 'mx/device-management/inventory',
    element: <MeterInventoryManager />
  },
  {
    path: 'mx/device-management/service-order',
    element: <WorkOrders />
  },
   {
    path: 'mx/device-management/service-order/create',
    element: <CreateServiceOrder />
  },
];
